import React, { useEffect, useState } from "react";
import { getListMonitoringSyncIHS, headCellsSync, sync } from "./utils";
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { Grid, Paper, TableCell, TableRow, Tooltip } from "@material-ui/core";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Title,
} from "App/Component/ui";
import { Sync } from "@material-ui/icons";
import { FreezeTable } from "components/organism";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { Skeleton } from "@material-ui/lab";
import { DISABLED_BUTTON_SUBMIT } from "App/constants";

const SHOW_RESTART_BUTTON = {
  label: "JALANKAN ANTRIAN SINGKRONISASI",
  color: "#296218",
  state: false,
  disabled: false,
};

export default function ToggleMonitoringSyncIHS() {
  const [loading, setLoading] = useState(false);
  const [loadingSync, setLoadingSync] = useState(false);
  const [proses, setProses] = useState([]);
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [disabledRestart, setDisabledRestart] = useState(SHOW_RESTART_BUTTON);

  console.log(proses, "propses");

  const fetchData = async (pages = 1, limit = 10) => {
    setLoading(true);
    const res = await getListMonitoringSyncIHS(pages, limit);
    if (res.state) {
      setRows(res.data);
      setProses(res.proses);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: fetchData });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "",
    orderByRow: [],
  });

  const jalanRekonsilRekrusif = async () => {
    setLoadingSync(true);
    setDisabledRestart(DISABLED_BUTTON_SUBMIT);
    const res = await sync();
    if (res.state) {
      defaultToastSuccess(res.message);
      resetPagination();
      fetchData();
    } else {
      defaultToastError(res.message);
      setLoadingSync(false);
    }
    setDisabledRestart(SHOW_RESTART_BUTTON);
  };

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Title title="Monitoring Singkronisasi Satu Sehat Berjalan" />
      </Grid>
      <div className="p-1">
        <Grid container spacing={1}>
          <Grid item md={6}>
            <Paper className="p-1">
              <p
                style={{
                  textAlign: "center",
                  fontSize: "1vw",
                  fontWeight: 800,
                }}
              >
                SEDANG PROSES
              </p>
              <p style={{ textAlign: "center", fontSize: "3vw" }}>
                {formatRupiah(proses?.length ?? 0)}
              </p>
            </Paper>
          </Grid>
          <Grid item md={6}>
            <Paper className="p-1">
              <p
                style={{
                  textAlign: "center",
                  fontSize: "1vw",
                  fontWeight: 800,
                }}
              >
                TOTAL ANTRIAN
              </p>
              <p style={{ textAlign: "center", fontSize: "3vw" }}>
                {formatRupiah(totalData ?? 0)}
              </p>
            </Paper>
          </Grid>
          <Grid item md={12}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                width: "100%",
              }}
            >
              <button
                type="button"
                disabled={disabledRestart.state}
                onClick={
                  proses.length > 0 ? null : () => jalanRekonsilRekrusif()
                }
                style={{
                  background:
                    proses.length > 0 ? "#D8D8D8" : disabledRestart.color,
                  display: "block",
                  width: "100%",
                  color: "white",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  padding: "0.6rem 2rem",
                  fontSize: "15px",
                  marginTop: "25px",
                  cursor: "pointer",
                  marginBottom: "25px",
                }}
                className={`button-login`}
              >
                {disabledRestart.label}
              </button>

              <IconButtonDatatable
                style={{
                  backgroundColor: "#296218",
                  padding: "1.3rem 2rem",
                }}
                onClick={() => {
                  resetPagination();
                  fetchData();
                }}
              >
                <Tooltip title={"Perbarui Data"} aria-label="update">
                  <Sync fontSize={"large"} style={{ color: "#fff" }} />
                </Tooltip>
              </IconButtonDatatable>
            </div>
          </Grid>
          <Grid item md={12} style={{ marginBottom: "1.5rem" }}>
            <FreezeTable
              headCells={headCellsSync}
              handleRequestSort={handleRequestSort}
              order={order}
              length={length}
              orderBy={orderBy}
            >
              {loading
                ? [1, 2, 3, 4, 5, 6, 7].map(() => (
                    <TableRow>
                      {headCellsSync.map(() => (
                        <TableCell>
                          <Skeleton animation="wave" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : stableSort(rows, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow hover key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="left">
                            {isNull(row?.id) ? "-" : row?.id}
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.fullname) ? "-" : row?.fullname}
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.dp_nik) ? "-" : row?.dp_nik}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
            </FreezeTable>
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
}
